import { inject, Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  private readonly router = inject(Router);

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  public constructor() {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
        this.currentUrl = events[1].urlAfterRedirects;
      });
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }

  public getCurrentUrl(): string {
    return this.currentUrl;
  }

  public setPreviousUrl(previousUrl: string): void {
    this.previousUrl = previousUrl;
  }
}
